import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";

import {navBarFixed, newsTicker} from "../marketing/global";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

document.addEventListener('DOMContentLoaded', function () {
    newsTicker()
    navBarFixed()

    ScrollTrigger.config({
        autoRefreshEvents: "DOMContentLoaded,load"
    });
    ScrollSmoother.create({
        smooth: 1.5,
        smoothTouch: 0.1
    })
})